/** @flow */

import type { State } from "@store/reducers";
import type {
  MySavedReports,
  DefaultReports,
  RtwDetailsReportViewState,
  RtwInterviewModal,
} from "@modules/reporting/reducer/reports/rtw-details/types";
import type { PaginationType } from "@types";

export const defaultReports = (state: State): Array<DefaultReports> =>
  state.reporting.reports.rtwDetails.defaultReports;

export const mySavedReports = (state: State): Array<MySavedReports> =>
  state.reporting.reports.rtwDetails.mySavedReports;

export const getReportData = (state: State): Array<Object> =>
  state.reporting.reports.rtwDetails.reportData.content;

export const getRtwReportPagination: (state: State) => PaginationType = state => {
  return (((state.reporting || {}).reports || {}).rtwDetails || {}).reportData.pagination;
};

export const getRtwReportDataTotalElements = (state: State): number => {
  return (((state.reporting || {}).reports || {}).rtwDetails || {}).reportData.totalElements;
};

export const getCurrentReport = (state: State): Object | null =>
  (state.reporting.reports.rtwDetails.currentReport || {}).report;

export const getCurrentCharts = (state: State): ?Object =>
  state.reporting.reports.rtwDetails.currentCharts;

export const getRTWDetailsFiltersSchema = (state: State): ?Object =>
  state.reporting.reports.rtwDetails.rtwDetailsFiltersSchema;

export const getReportToSave = (state: State): ?Object =>
  state.reporting.reports.rtwDetails.reportToSave;

export const getRtwInterviewModalState = (state: State): RtwInterviewModal =>
  state.reporting.reports.rtwDetails.modals.rtwInterview;

export const getViewState = (state: State): RtwDetailsReportViewState =>
  state.reporting.reports.rtwDetails.viewState;

export const isLoading = (state: State): boolean =>
  state.reporting.reports.rtwDetails.requestsInProgress > 0;

export const isReportGenerateInProgress = (state: State): boolean =>
  state.reporting.reports.rtwDetails.reportGenerateInProgress > 0;
